import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    overflowX: 'hidden',
    height: '57vh !important',
    position: 'relative',
  },
  headFilter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonClose: {
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
  },
  button: {
    width: '152px',
    backgroundColor: '#026894',
    color: '#FFF',
    paddingTop: '5px',
    paddingBottom: '5px',
    paddingRight: '2px',
    paddingLeft: '2px',
    boxShadow: 'none',
    position: 'relative',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '12px',
    borderRadius: '6px',
    textAlign: 'center',
    textDecoration: 'none',
    marginLeft: '25px',
    lineHeight: 1.75,
    '&:hover': { backgroundColor: '#026894' },
  },
  buttonVisualize: { marginRight: '16px' },
  buttonEdit: { marginRight: '2%' },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '100%',
    padding: '8px 0',
    marginTop: '9px',
    borderRadius: '2px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  table: { width: '100%' },
  selectStatus: {
    width: '100%',
    border: '1px solid #ccc',
    padding: '7px 6px',
    marginTop: '10px',
  },
  inputFilter: {
    width: '100%',
    border: '1px solid #ccc',
    padding: '7px 6px',
    marginTop: '10px',
    background: '#fff',
    color: '#333',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '63px',
    paddingRight: '10px',
    marginBottom: '19px',
  },
  filtersBox: {
    position: 'absolute',
    marginTop: '172px',
    background: '#185b86',
    width: '315px',
    color: '#fff',
    padding: '10px',
    zIndex: '99',
    right: '0',
    marginRight: '9px',
    borderRadius: '5px',
  },
  labelFilter: { fontSize: '14px', fontWeight: 'bold' },
}));

export default useStyles;
